import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import {
    ADD_PROXIES_FAILURE,
    ADD_PROXIES_SUCCESS,
    GET_PROXY_USER_LIST_SUCCESS,
    GET_PROXY_USER_LIST_FAILURE,
    GET_PROXY_LIST_FAILURE,
    GET_PROXY_LIST_SUCCESS,
    UPDATE_PROXY_SUCCESS,
    UPDATE_PROXY_FAILURE,
} from 'src/pages/more/pages/proxies/redux/action/actionTypes.js';

import {
    addProxiesService,
    getProxyUserListService,
    getProxyListService,
    updateProxiesService,
} from 'src/pages/more/pages/proxies/redux/services/index.js';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* addProxies(action) {
    try {
        const result = yield addProxiesService(action.payload);
        yield put({ type: ADD_PROXIES_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/addproxy`,
            requestPayload: action.payload,
        });
        yield put({
            type: ADD_PROXIES_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* updateProxy(action) {
    try {
        const result = yield updateProxiesService(action.payload);
        yield put({ type: UPDATE_PROXY_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/updateProxy`,
            requestPayload: action.payload,
        });
        yield put({
            type: UPDATE_PROXY_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getProxyUserList(action) {
    try {
        const result = yield getProxyUserListService(action.payload);
        yield put({ type: GET_PROXY_USER_LIST_SUCCESS, proxyUserList: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/getProxyUsers`,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_PROXY_USER_LIST_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getProxyList() {
    try {
        const result = yield getProxyListService();

        yield put({ type: GET_PROXY_LIST_SUCCESS, proxyList: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `/occ/v2/${localStorage.getItem('baseSiteId')}/proxy/proxies`,
        });
        yield put({
            type: GET_PROXY_LIST_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
